__webpack_require__.p = "https://dev.menu.awandigital.id/";